export default __webpack_public_path__ + "static/media/loading_compressed_super.74150b53.gif";